type SloHeatmapData = {
  count: number;
  state: 'ok' | 'risk' | 'breach' | 'gathering';
};

export const parseClusterScore = (score?: string | null): number | null => {
  if (score == null || score === '') {
    return null;
  }

  const parsed = Number(score);
  return Number.isFinite(parsed) ? parsed : null;
};

export const deriveSloFromClusterScore = (
  score: number | null
): SloHeatmapData => {
  if (score == null) {
    return { state: 'gathering', count: 0 };
  }

  if (score >= 70) {
    return { state: 'ok', count: 0 };
  }

  if (score >= 50) {
    return { state: 'risk', count: Math.max(1, Math.round((70 - score) / 5)) };
  }

  return {
    state: 'breach',
    count: Math.max(1, Math.round((50 - score) / 5)),
  };
};

export const deriveSloFromUnhealthyWorkloads = (
  unhealthyWorkloads: number | null
): SloHeatmapData | null => {
  if (unhealthyWorkloads == null) {
    return null;
  }

  if (unhealthyWorkloads === 0) {
    return { state: 'ok', count: 0 };
  }

  if (unhealthyWorkloads <= 2) {
    return { state: 'risk', count: unhealthyWorkloads };
  }

  return { state: 'breach', count: unhealthyWorkloads };
};
